export default __webpack_public_path__ + "static/media/demo_delidding.a54da66d.webp";